export const SET_TEAM_NAME = 'SET_TEAM_NAME';
export const SET_TEAM_HAS_PAID = 'SET_TEAM_HAS_PAID';
export const SET_RIDDLES = 'SET_RIDDLES';
export const SET_RIDDLE = 'SET_RIDDLE'
export const SET_RIDDLE_SOLVED = 'SET_RIDDLE_SOLVED';
export const SET_RIDDLES_SOLVED = 'SET_RIDDLES_SOLVED';
export const SET_QUESTS = 'SET_QUESTS';
export const SET_QUEST_DONE = 'SET_QUEST_DONE';
export const SET_QUESTS_DONE = 'SET_QUESTS_DONE';
